import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToppingsPicker from '../../ToppingsPicker';
import { selectors } from '../../../../slice/pizza.slice';
import { debouncedUpdateMeatToppings, debouncedUpdateVeggieToppings } from '../../../../slice/debouncedActions';
import { useExtraToppingPricing } from '../../../../hooks/pizzaPricing';
import { PizzaIngredient } from '@/builders/pizza/dataTransformers/builderTypes';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '-26px',
    marginTop: '-4px'
  }
}));

const ToppingsSetterDesktop = (): JSX.Element => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const meatToppingsOptions = useSelector(selectors.selectMeatToppingOptions);
  const veggieToppingsOptions = useSelector(selectors.selectVeggieToppingsOptions);
  const selectedMeatToppings = useSelector(selectors.selectPizzaMeatToppings);
  const selectedVeggieToppings = useSelector(selectors.selectPizzaVeggieToppings);

  const handleAddMeatToppings = (toppings: PizzaIngredient[]) => {
    dispatch(debouncedUpdateMeatToppings(toppings));
  };

  const handleAddVeggieToppings = (toppings: PizzaIngredient[]) => {
    dispatch(debouncedUpdateVeggieToppings(toppings));
  };

  const { meatPrice, veggiePrice } = useExtraToppingPricing();

  return (
    <Grid container direction="column" className={classes.root}>
      { (meatToppingsOptions.length > 0) && (
      <ToppingsPicker
        title="Meats"
        toppingOptions={meatToppingsOptions}
        selectedToppings={selectedMeatToppings}
        onToppingsUpdate={handleAddMeatToppings}
        extraPrice={meatPrice}
      />
      )}
      { (veggieToppingsOptions.length > 0) && (
      <ToppingsPicker
        title="Veggies"
        toppingOptions={veggieToppingsOptions}
        selectedToppings={selectedVeggieToppings}
        onToppingsUpdate={handleAddVeggieToppings}
        extraPrice={veggiePrice}
      />
      )}
    </Grid>
  );
};

export default ToppingsSetterDesktop;
